import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.healthCheckQuestions.loading;
export const selectErrorMessage = (state: RootState) =>
  state.healthCheckQuestions.error;
export const healthCheckQuestionsResponse = (state: RootState) =>
  state.healthCheckQuestions.healthCheckQuestionsResponse;
